module.exports = __webpack_public_path__ + "img/easyset-mobile.e27bc35b.jpg";